import { useTranslation } from "react-i18next";
import { ArrowIcon, MWebAddons, SeeMoreButton } from "./styles";
import { Popup } from "components/popup";
import { useState } from "react";
import { PopupBody } from "components/popup/body";
import { PopupHeader } from "components/popup/header";
import { AddOns } from "../../add-ons";
import { PopupButton } from "components/popup/button";
import { useActiveCoverage } from "screens/offer-bc/utils";
import { SlideTransition } from "./slide-transition";

export function AddonsButton() {
  const { t } = useTranslation("screens", { keyPrefix: "offer.addOns" });
  const hasActiveAddedCoverage = useActiveCoverage();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function toggleAddOnsDialog() {
    setIsDialogOpen((p) => !p);
  }

  return (
    <>
      <MWebAddons onClick={toggleAddOnsDialog}>
        {t("title")}
        <SeeMoreButton>
          <ArrowIcon className="right" />
        </SeeMoreButton>
      </MWebAddons>
      <Popup open={isDialogOpen} TransitionComponent={SlideTransition}>
        <PopupHeader
          onClose={toggleAddOnsDialog}
          closePosition="left"
          closeIcon={<ArrowIcon />}
          screen
        />
        <PopupBody screen>
          <AddOns />
          <PopupButton
            variant="outlined"
            type="submit"
            disabled={!hasActiveAddedCoverage}
            onClick={toggleAddOnsDialog}
          >
            {t("addOfferCta")}
          </PopupButton>
        </PopupBody>
      </Popup>
    </>
  );
}
